import React from "react";
import {connect} from 'dva';
import './tab.less'

function Tab(props) {

    const {ids, showType, isTemplate, deployConfigInfo, LOCALE_HTML, dispatch} = props;
    const { historyTicketFlag } = deployConfigInfo.item || {};
    const len = (deployConfigInfo.items || []).length;

    const setShowType = (paramShowType, type) => {
        if (paramShowType === 0 && type === 'msg'){
            if (showType === 1){
                return;
            }
        }
        if(len === 1 && paramShowType === 0){
            dispatch({
                type: 'app/getList',
                payload: {
                    ...ids,
                    templateId: deployConfigInfo.items[0].templateId,
                    showType: 1
                }
            });
        } else {
            dispatch({
                type: 'app/changeItem',
                payload: paramShowType
            })
        }
    };
    // const close = () => {
    //     if (window.parent.length > 0){
    //         window.parent.postMessage({type: 'zhichi-ticketclient-close'}, '*');
    //     }else{
    //         if(window.history.length === 1){//target="_blank"
    //             window.close()
    //         }
    //     }
    // };

    const goBack = (showType) => {
        if(showType === 4){
            setShowType(3)
        }else{
            if(isTemplate){
                if(showType === 1 || showType === 3){
                    setShowType(0)
                }
                if(showType === 0){
                    window.location.href = document.referrer
                }
            }else{
                window.location.href = document.referrer
            }
        }
    };

    const renderBack = ()=> {
        const back = (
            <div className="back-wrap" onClick={() => goBack(showType)}>
                <svg className="back-icon" aria-hidden="true"><use xlinkHref="#iconfanhui-fencengyemianyong2"/></svg>
                <span className="back-text">{LOCALE_HTML['msg.back']}</span>
            </div>
        )
        if(showType === 4){
            return back
        }else{
            if(isTemplate){
                if(showType === 1 || showType === 3){
                    return back
                }
                if(showType === 0 && document.referrer && !window.parent){
                    if(window.history.length > 1){
                        return back
                    }
                }
            }else{
                if(document.referrer && !window.parent){
                    if(window.history.length > 1){
                        return back
                    }
                }
            }
        }
    }

    return (
        <div className="header-wrap">
            {
                renderBack()
            }
            {
                deployConfigInfo.item.deployName === '历史工单' ? (
                    <div className="zc-j-tab">
                        <div className={`zc-tab-item ${showType === 3 ? 'active' : ''}`} onClick={() => setShowType(3)}>
                            {deployConfigInfo.item.listTitle}
                        </div>
                    </div>
                ) : (
                    historyTicketFlag === 0 ? <div className="single-header">{deployConfigInfo.item.msgTitle}</div> : (
                        showType === 4 ? <div className="single-header">{deployConfigInfo.item.detailTitle}</div> : (
                                <div className="zc-j-tab">
                                    <div className={`zc-tab-item first ${showType === 0 || showType === 1 || showType === 2 ? 'active' : ''}`} onClick={() => setShowType(0, 'msg')}>
                                        {deployConfigInfo.item.msgTitle}
                                    </div>
                                    <div className={`zc-tab-item ${showType === 3 ? 'active' : ''}`} onClick={() => setShowType(3)}>
                                        {deployConfigInfo.item.listTitle}
                                    </div>
                            </div>
                        )
                    )
                )
            }
            {/*{*/}
            {/*    window.parent.length > 0 || window.history.length === 1 ? <div className="close-icon" onClick={() => close()}>×</div> : null*/}
            {/*}*/}
        </div>
    )
}

const mapState = state => {
    const {ids, showType, isTemplate, deployConfigInfo} = state.app;
    const { LOCALE_HTML } = state.locale;
    return {
        ids,
        showType,
        isTemplate,
        deployConfigInfo,
        LOCALE_HTML
    };
};

export default connect(mapState)(Tab);
